import { FETCH_DOCTOR_PROFILE_SUCCESS } from '../action/profile';

const initialState = {
  profile: null
};

const doctorProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCTOR_PROFILE_SUCCESS:
      return {
        ...state,
        profile: { ...action.payload }
      };

    default:
      return state;
  }
};

export default doctorProfileReducer;
